import { Component } from 'react';

import { Box } from '@mui/material';

export default class Home extends Component {
  componentDidMount() {
    document.title = 'LeKinaSá | Personal Page';
  }

  render() {
    return (
      <Box className='welcome fill-screen center-flex'>
        <Box className='center-screen'>
          <Box className='big-text'>
            <p>
              Hi, I'm Clara Martins,
            </p>
            <p>
              also known as LeKinaSá.
            </p>
            <p>
              Nice to meet you.
            </p>
          </Box>
          <Box className='large-text spaced'>
            Check out more <a className='link' href='/about'>about me</a> or <a className='link' href='/projects'>my projects</a>!
          </Box>
        </Box>
      </Box>
    );
  }
}
